
// import React, { useState, useEffect, useRef } from 'react';
// import { Box, Typography, InputBase, IconButton, CircularProgress, Avatar } from '@mui/material';
// import { useSelector, useDispatch } from 'react-redux';
// import { AccountCircle } from '@mui/icons-material';
// import propertyImage from '../assets/inmenu.png';
// import userAvatar from '../assets/inboxuser.png';
// import agentAvatar from '../assets/inboxavatar.png';
// import attachIcon from '../assets/clipprof.png';
// import photoIcon from '../assets/clippho.png';
// import locationIcon from '../assets/cliploc.png';
// import sendIcon from '../assets/rocket.png';
// import tickIcon from '../assets/doubletick.png';
// import inboxheader from '../assets/inhead.png';
// import { setCurrentConversationId, setSenderId, setReceiverId, setConversations } from '../Commonlibs/userSlice';
// import Loader from '../Loader/Loader';

// // SVG icons for different message statuses
// const singleTickSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
// <path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;

// const doubleTickSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
// <path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M0.5 8L4.5 12L11.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;

// const doubleTickBlueSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
// <path d="M2.5 8L6.5 12L13.5 5" stroke="#2563eb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M0.5 8L4.5 12L11.5 5" stroke="#2563eb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;

// const ProfileInbox = () => {
//   const [conversations, setLocalConversations] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConversation, setSelectedConversation] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [loadingMessages, setLoadingMessages] = useState(false);
//   const [messageError, setMessageError] = useState(null);
//   const [inputMessage, setInputMessage] = useState('');
//   const [currentConversationId, setLocalCurrentConversationId] = useState(null);
//   const [receiverId, setLocalReceiverId] = useState(null);
//   const [sendingMessage, setSendingMessage] = useState(false);
//   const [otherUserOnlineStatus, setOtherUserOnlineStatus] = useState(false);
//   const [otherUserLoggedInStatus, setOtherUserLoggedInStatus] = useState(false);

//   const onlineStatusIntervalRef = useRef(null);

//   const user = useSelector((state) => state.user.user);
//   const dispatch = useDispatch();

//   const userId = user?.id;

//   // Function to convert base64 to image URL
//   const convertBase64ToImageUrl = (base64String) => {
//     if (!base64String) return null;
    
//     if (base64String.startsWith('data:image')) {
//       return base64String;
//     }
    
//     if (base64String.startsWith('/9j/') || base64String.startsWith('iVBOR')) {
//       return `data:image/jpeg;base64,${base64String}`;
//     }
    
//     return null;
//   };

//   const checkOtherUserOnlineStatus = async (otherUserId) => {
//     if (!otherUserId) {
//       console.log('No other user ID available, skipping online status check');
//       return;
//     }

//     try {
//       console.log(`Checking online status for other user ID: ${otherUserId}`);
//       const apiUrl = `https://propertydealstalk.com/api/messaging/updateOnlineStatus`;
//       console.log('Other User Online Status API URL:', apiUrl);

//       const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: otherUserId,
//           is_online: true
//         })
//       });

//       if (!response.ok) {
//         console.error('Other user online status API response not OK:', response.status, response.statusText);
//         throw new Error(`Other user online status API request failed with status ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Other user online status API response:', data);

//       if (data.statusCode === 200) {
//         const isOnline = data.result?.is_online || false;
//         const isLoggedIn = data.result?.is_logged_in || false;
//         console.log(`Other user (${otherUserId}) online status:`, isOnline);
//         console.log(`Other user (${otherUserId}) logged in status:`, isLoggedIn);

//         const prevOnlineStatus = otherUserOnlineStatus;
//         const prevLoggedInStatus = otherUserLoggedInStatus;
//         setOtherUserOnlineStatus(isOnline);
//         setOtherUserLoggedInStatus(isLoggedIn);

//         setSelectedConversation(prevConversation => {
//           if (!prevConversation) return prevConversation;
//           return {
//             ...prevConversation,
//             is_other_user_online: isOnline,
//             is_other_user_logged_in: isLoggedIn
//           };
//         });

//         setMessages(prevMessages =>
//           prevMessages.map(msg => {
//             if (msg.sender_id === userId) {
//               if (!prevLoggedInStatus && isLoggedIn && msg.status === 'sent') {
//                 return { ...msg, status: 'delivered' };
//               }
//               else if (msg.status === 'read') {
//                 return msg;
//               }
//               else if (isOnline && msg.status === 'delivered') {
//                 return { ...msg, status: 'read' };
//               }
//               else if (prevLoggedInStatus && !isLoggedIn) {
//                 return { ...msg, status: 'sent' };
//               }
//             }
//             return msg;
//           })
//         );
//       } else {
//         console.error('Other user online status API returned non-200 status code:', data.statusCode);
//       }
//     } catch (err) {
//       console.error('Error checking other user online status:', err);
//     }
//   };

//   useEffect(() => {
//     if (!userId) {
//       console.log('No user ID available, skipping online status update');
//       return;
//     }

//     const updateOnlineStatus = async () => {
//       try {
//         console.log(`Updating online status for user ID: ${userId}`);
//         const apiUrl = `https://propertydealstalk.com/api/messaging/updateOnlineStatus`;
//         console.log('Online Status API URL:', apiUrl);

//         const response = await fetch(apiUrl, {
//           method: 'POST',
//           headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             user_id: userId,
//             is_online: true
//           })
//         });

//         if (!response.ok) {
//           console.error('Online status update API response not OK:', response.status, response.statusText);
//           throw new Error(`Online status update API request failed with status ${response.status}`);
//         }

//         const data = await response.json();
//         console.log('Online status update API response:', data);

//         if (data.statusCode !== 200) {
//           console.error('Online status update API returned non-200 status code:', data.statusCode);
//           throw new Error(data.message || 'Failed to update online status');
//         }
//       } catch (err) {
//         console.error('Error updating online status:', err);
//       }
//     };

//     updateOnlineStatus();
//     const intervalId = setInterval(updateOnlineStatus, 1 * 60 * 1000);

//     const handleBeforeUnload = () => {
//       fetch(`https://propertydealstalk.com/api/messaging/updateOnlineStatus`, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           is_online: false
//         }),
//         keepalive: true
//       }).catch(err => console.error('Error updating offline status:', err));
//     };

//     window.addEventListener('beforeunload', handleBeforeUnload);

//     return () => {
//       clearInterval(intervalId);
//       window.removeEventListener('beforeunload', handleBeforeUnload);
//       fetch(`https://propertydealstalk.com/api/messaging/updateOnlineStatus`, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           is_online: false
//         }),
//         keepalive: true
//       }).catch(err => console.error('Error updating offline status on unmount:', err));
//     };
//   }, [userId]);

//   useEffect(() => {
//     if (onlineStatusIntervalRef.current) {
//       clearInterval(onlineStatusIntervalRef.current);
//       onlineStatusIntervalRef.current = null;
//     }

//     if (!receiverId) {
//       return;
//     }

//     checkOtherUserOnlineStatus(receiverId);

//     onlineStatusIntervalRef.current = setInterval(() => {
//       checkOtherUserOnlineStatus(receiverId);
//     }, 5 * 1000);

//     return () => {
//       if (onlineStatusIntervalRef.current) {
//         clearInterval(onlineStatusIntervalRef.current);
//         onlineStatusIntervalRef.current = null;
//       }
//     };
//   }, [receiverId]);

//   const markMessagesAsRead = async (conversationId) => {
//     if (!userId || !conversationId) {
//       console.log('Missing user ID or conversation ID, skipping mark as read');
//       return;
//     }

//     try {
//       console.log(`Marking messages as read for conversation ID: ${conversationId}, user ID: ${userId}`);
//       const apiUrl = `https://propertydealstalk.com/api/messaging/markMessagesAsRead`;
//       console.log('Mark as Read API URL:', apiUrl);

//       const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           conversation_id: conversationId,
//           user_id: userId
//         })
//       });

//       if (!response.ok) {
//         console.error('Mark as read API response not OK:', response.status, response.statusText);
//         throw new Error(`Mark as read API request failed with status ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Mark as read API response:', data);

//       if (data.statusCode !== 200) {
//         console.error('Mark as read API returned non-200 status code:', data.statusCode);
//         throw new Error(data.message || 'Failed to mark messages as read');
//       }

//       console.log(`Successfully marked ${data.result.messages_updated} messages as read`);

//       setLocalConversations(prevConversations =>
//         prevConversations.map(conv =>
//           conv.conversation_id === conversationId
//             ? {
//                 ...conv,
//                 last_message: {
//                   ...conv.last_message,
//                   status: 'read'
//                 }
//               }
//             : conv
//         )
//       );

//       setMessages(prevMessages =>
//         prevMessages.map(msg =>
//           msg.sender_id !== userId && msg.status !== 'read'
//             ? { ...msg, status: 'read' }
//             : msg
//         )
//       );
//     } catch (err) {
//       console.error('Error marking messages as read:', err);
//     }
//   };

//   useEffect(() => {
//     if (!userId) {
//       console.log('No user ID available, skipping API call');
//       return;
//     }

//     const fetchConversations = async () => {
//       setLoading(true);
//       try {
//         console.log(`Fetching conversations for user ID: ${userId}`);
//         const apiUrl = `https://propertydealstalk.com/api/messaging/conversations?user_id=${userId}`;
//         console.log('API URL:', apiUrl);

//         const response = await fetch(apiUrl, {
//           method: 'GET',
//           headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//             'Cache-Control': 'no-cache, no-store'
//           }
//         });

//         if (!response.ok) {
//           console.error('API response not OK:', response.status, response.statusText);
//           throw new Error(`API request failed with status ${response.status}`);
//         }

//         const data = await response.json();
//         console.log('API response:', data);

//         if (data.statusCode === 200) {
//           console.log('Conversations data:', data.result);

//           const processedConversations = data.result.map(conversation => {
//             const imageUrl = convertBase64ToImageUrl(conversation.property?.image);
            
//             return {
//               ...conversation,
//               property: {
//                 ...conversation.property,
//                 image: imageUrl || propertyImage
//               }
//             };
//           });

//           setLocalConversations(processedConversations);

//           if (processedConversations && processedConversations.length > 0) {
//             try {
//               dispatch(setConversations(processedConversations));
//             } catch (err) {
//               console.error('Error updating Redux state:', err);
//             }
//           }

//           if (processedConversations.length > 0 && !currentConversationId) {
//             const firstConversation = processedConversations[0];
//             setSelectedConversation(firstConversation);
//             setLocalCurrentConversationId(firstConversation.conversation_id);

//             if (firstConversation.other_user && firstConversation.other_user.id) {
//               const otherUserId = firstConversation.other_user.id;
//               setLocalReceiverId(otherUserId);
//               checkOtherUserOnlineStatus(otherUserId);
//               try {
//                 dispatch(setReceiverId(otherUserId));
//               } catch (err) {
//                 console.error('Error updating Redux receiver ID:', err);
//               }
//             }

//             try {
//               dispatch(setCurrentConversationId(firstConversation.conversation_id));
//               if (firstConversation.other_user && firstConversation.other_user.id) {
//                 dispatch(setSenderId(firstConversation.other_user.id));
//               }
//             } catch (err) {
//               console.error('Error updating Redux state:', err);
//             }

//             fetchMessages(firstConversation.conversation_id);
//             markMessagesAsRead(firstConversation.conversation_id);
//           } else if (currentConversationId) {
//             const existingConversation = processedConversations.find(
//               conv => conv.conversation_id === currentConversationId
//             );
//             if (existingConversation) {
//               setSelectedConversation(existingConversation);
//               if (existingConversation.other_user && existingConversation.other_user.id) {
//                 const otherUserId = existingConversation.other_user.id;
//                 setLocalReceiverId(otherUserId);
//                 checkOtherUserOnlineStatus(otherUserId);
//                 try {
//                   dispatch(setReceiverId(otherUserId));
//                 } catch (err) {
//                   console.error('Error updating Redux receiver ID:', err);
//                 }
//               }
//               fetchMessages(currentConversationId);
//               markMessagesAsRead(currentConversationId);
//             }
//           }
//         } else {
//           console.error('API returned non-200 status code:', data.statusCode);
//           throw new Error(data.message || 'Failed to fetch conversations');
//         }
//       } catch (err) {
//         console.error('Error fetching conversations:', err);
//         console.error('Error details:', err.message);
//         console.error('Error stack:', err.stack);
//         setError(`Error: Failed to fetch. Please try again later.`);
//         setLocalConversations([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchConversations();
//   }, [userId, dispatch]);

//   const fetchMessages = async (conversationId) => {
//     if (!userId || !conversationId) {
//       console.log('Missing user ID or conversation ID, skipping message fetch');
//       return;
//     }

//     setLoadingMessages(true);
//     setMessageError(null);

//     try {
//       console.log(`Fetching messages for conversation ID: ${conversationId}, user ID: ${userId}`);
//       const apiUrl = `https://propertydealstalk.com/api/messaging/getMessages?conversation_id=${conversationId}&user_id=${userId}`;
//       console.log('Messages API URL:', apiUrl);

//       const response = await fetch(apiUrl, {
//         method: 'GET',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//           'Cache-Control': 'no-cache, no-store'
//         }
//       });

//       if (!response.ok) {
//         console.error('Messages API response not OK:', response.status, response.statusText);
//         throw new Error(`Messages API request failed with status ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Messages API response:', data);

//       if (data.statusCode === 200) {
//         console.log('Messages data:', data.result.messages);
//         const messagesArray = Array.isArray(data.result.messages) ? data.result.messages : [];

//         const processedMessages = messagesArray.map(msg => {
//           if (msg.sender_id === userId) {
//             if (!msg.status) {
//               if (otherUserOnlineStatus) {
//                 return { ...msg, status: 'read' };
//               } else if (otherUserLoggedInStatus) {
//                 return { ...msg, status: 'delivered' };
//               } else {
//                 return { ...msg, status: 'sent' };
//               }
//             }
//           } else {
//             return { ...msg, status: 'read' };
//           }
//           return msg;
//         });

//         setMessages(processedMessages);

//         if (!receiverId && selectedConversation?.other_user?.id) {
//           const otherUserId = selectedConversation.other_user.id;
//           setLocalReceiverId(otherUserId);
//           checkOtherUserOnlineStatus(otherUserId);
//           try {
//             dispatch(setReceiverId(otherUserId));
//           } catch (err) {
//             console.error('Error updating Redux receiver ID:', err);
//           }
//         }

//         markMessagesAsRead(conversationId);
//       } else {
//         console.error('Messages API returned non-200 status code:', data.statusCode);
//         throw new Error(data.message || 'Failed to fetch messages');
//       }
//     } catch (err) {
//       console.error('Error fetching messages:', err);
//       console.error('Error details:', err.message);
//       setMessageError('Failed to load messages. Please try again later.');
//       setMessages([]);
//     } finally {
//       setLoadingMessages(false);
//     }
//   };

//   const sendMessage = async (messageText) => {
//     if (!messageText.trim()) {
//       console.log('Message text is empty');
//       return;
//     }

//     if (!currentConversationId) {
//       console.log('Missing conversation ID');
//       return;
//     }

//     if (!userId) {
//       console.log('Missing user ID');
//       return;
//     }

//     let actualReceiverId = receiverId;
//     if (!actualReceiverId && selectedConversation?.other_user?.id) {
//       actualReceiverId = selectedConversation.other_user.id;
//       setLocalReceiverId(actualReceiverId);
//       checkOtherUserOnlineStatus(actualReceiverId);
//       try {
//         dispatch(setReceiverId(actualReceiverId));
//       } catch (err) {
//         console.error('Error updating Redux receiver ID:', err);
//       }
//     }

//     if (!actualReceiverId) {
//       console.log('Missing receiver ID and cannot determine from conversation');
//       return;
//     }

//     setSendingMessage(true);

//     try {
//       let initialStatus = 'sent';
//       if (otherUserOnlineStatus) {
//         initialStatus = 'read';
//       } else if (otherUserLoggedInStatus) {
//         initialStatus = 'delivered';
//       }

//       const tempMessage = {
//         message_id: `temp-${Date.now()}`,
//         message_text: messageText,
//         sender_id: userId,
//         sender_name: user?.full_name || 'You',
//         receiver_id: actualReceiverId,
//         receiver_name: 'Receiver',
//         timestamp: new Date().toISOString(),
//         status: initialStatus
//       };

//       setMessages(prevMessages => [...prevMessages, tempMessage]);
//       setInputMessage('');

//       const apiUrl = 'https://propertydealstalk.com/api/messaging/sendMessage';
//       console.log('Send Message API URL:', apiUrl);

//       const requestBody = {
//         conversation_id: currentConversationId,
//         receiver_id: actualReceiverId,
//         sender_id: userId,
//         message_text: messageText
//       };

//       console.log('Sending message with data:', requestBody);

//       const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(requestBody)
//       });

//       if (!response.ok) {
//         console.error('Send message API response not OK:', response.status, response.statusText);
//         throw new Error(`Send message API request failed with status ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Send message API response:', data);

//       if (data.statusCode === 200) {
//         console.log('Message sent successfully:', data.result);

//         setMessages(prevMessages =>
//           prevMessages.map(msg =>
//             msg.message_id === tempMessage.message_id
//               ? {
//                   ...msg,
//                   message_id: data.result.message_id,
//                   timestamp: data.result.timestamp,
//                   status: initialStatus
//                 }
//               : msg
//           )
//         );
//       } else {
//         console.error('Send message API returned non-200 status code:', data.statusCode);
//         throw new Error(data.message || 'Failed to send message');
//       }
//     } catch (err) {
//       console.error('Error sending message:', err);
//       console.error('Error details:', err.message);

//       setMessages(prevMessages =>
//         prevMessages.map(msg =>
//           msg.status === 'sending'
//             ? { ...msg, status: 'failed' }
//             : msg
//         )
//       );
//     } finally {
//       setSendingMessage(false);
//     }
//   };

//   const handleConversationSelect = (conversation) => {
//     setSelectedConversation(conversation);
//     setLocalCurrentConversationId(conversation.conversation_id);

//     if (conversation.other_user && conversation.other_user.id) {
//       const otherUserId = conversation.other_user.id;
//       setLocalReceiverId(otherUserId);
//       checkOtherUserOnlineStatus(otherUserId);
//       try {
//         dispatch(setReceiverId(otherUserId));
//       } catch (err) {
//         console.error('Error updating Redux receiver ID:', err);
//       }
//     }

//     try {
//       dispatch(setCurrentConversationId(conversation.conversation_id));
//       if (conversation.other_user && conversation.other_user.id) {
//         dispatch(setSenderId(conversation.other_user.id));
//       }
//     } catch (err) {
//       console.error('Error updating Redux state:', err);
//     }

//     fetchMessages(conversation.conversation_id);
//     markMessagesAsRead(conversation.conversation_id);
//   };

//   const formatRelativeTime = (timestamp) => {
//     if (!timestamp) return '';

//     try {
//       const now = new Date();
//       const messageTime = new Date(timestamp);

//       if (isNaN(messageTime.getTime())) {
//         console.error('Invalid date:', timestamp);
//         return 'Invalid date';
//       }

//       const diffInMs = now - messageTime;
//       const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

//       if (diffInMinutes < 1) return 'just now';
//       if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

//       const diffInHours = Math.floor(diffInMinutes / 60);
//       if (diffInHours < 24) return `${diffInHours}h ago`;

//       const diffInDays = Math.floor(diffInHours / 24);
//       if (diffInDays < 7) return `${diffInDays}d ago`;

//       return messageTime.toLocaleDateString();
//     } catch (error) {
//       console.error('Error formatting date:', error);
//       return 'Date error';
//     }
//   };

//   const formatMessageTime = (timestamp) => {
//     if (!timestamp) return '';

//     try {
//       const date = new Date(timestamp);

//       if (isNaN(date.getTime())) {
//         return 'Invalid time';
//       }

//       return date.toLocaleTimeString('en-US', {
//         hour: 'numeric',
//         minute: '2-digit',
//         hour12: true
//       });
//     } catch (error) {
//       console.error('Error formatting time:', error);
//       return 'Time error';
//     }
//   };

//   const getMessageStatusIcon = (status, isSentByCurrentUser) => {
//     if (!isSentByCurrentUser) return null;

//     switch (status) {
//       case 'sent':
//         return <div dangerouslySetInnerHTML={{ __html: singleTickSvg }} />;
//       case 'delivered':
//         return <div dangerouslySetInnerHTML={{ __html: doubleTickSvg }} />;
//       case 'read':
//         return <div dangerouslySetInnerHTML={{ __html: doubleTickBlueSvg }} />;
//       case 'failed':
//         return <Typography sx={{ color: 'red', fontSize: '10px' }}>Failed</Typography>;
//       default:
//         return <div dangerouslySetInnerHTML={{ __html: singleTickSvg }} />;
//     }
//   };

//   if (!userId) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px', flexDirection: 'column', gap: 2 }}>
//         <Typography variant="h6">Please log in to view your messages</Typography>
//         <Typography variant="body2" color="text.secondary">
//           You need to be logged in to access your conversations
//         </Typography>
//       </Box>
//     );
//   }

//   if (loading) return <Loader />;

//   return (
//     <Box
//       sx={{
//         flex: 1,
//         display: 'flex',
//         flexDirection: { xs: 'column', md: 'row' },
//         gap: { xs: '10px', md: '20px' },
//         width: '100%',
//       }}
//     >
//       {/* Inbox List */}
//       <Box
//         sx={{
//           width: { xs: '100%', md: '320px' },
//           background: '#fff',
//           borderRadius: '8px',
//           display: 'flex',
//           flexDirection: 'column',
//           overflowY: 'auto',
//           padding: { xs: '12px', md: '46px 16px 0 16px' }, // ✅ Fixed: Reduced mobile top padding from 20px to 12px
//         }}
//       >
//         {error ? (
//           <Box sx={{ padding: '20px', textAlign: 'center' }}>
//             <Typography sx={{ color: 'red', marginBottom: '10px' }}>
//               Error: Failed to fetch. Please try again later.
//             </Typography>
//           </Box>
//         ) : conversations.length > 0 ? (
//           conversations.map((conversation) => (
//             <Box
//               key={conversation.conversation_id}
//               sx={{
//                 display: 'flex',
//                 alignItems: 'flex-start',
//                 padding: '10px',
//                 border: '2px solid #f1f1f1',
//                 borderRadius: '9px',
//                 cursor: 'pointer',
//                 marginBottom: '12px', // ✅ Fixed: Reduced from 20px to 12px for better spacing
//                 backgroundColor: selectedConversation?.conversation_id === conversation.conversation_id ? '#f8f9fa' : 'transparent',
//               }}
//               onClick={() => handleConversationSelect(conversation)}
//             >
//               <img
//                 src={conversation.property.image}
//                 alt="Property"
//                 style={{
//                   width: '40px',
//                   height: '38px',
//                   borderRadius: '8px',
//                   marginRight: '12px',
//                   objectFit: 'cover',
//                 }}
//                 onError={(e) => {
//                   console.warn('Image failed to load, using fallback');
//                   e.target.src = propertyImage;
//                 }}
//               />
//               <Box sx={{ flex: 1 }}>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'flex-start',
//                   }}
//                 >
//                   <Typography sx={{ margin: 0, fontSize: '13px', fontWeight: 600 }}>
//                     {conversation.property.property_name}
//                   </Typography>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'flex-end',
//                     }}
//                   >
//                     {conversation.last_message.status !== 'read' && (
//                       <Box
//                         sx={{
//                           width: '8px',
//                           height: '8px',
//                           background: 'red',
//                           borderRadius: '50%',
//                         }}
//                       />
//                     )}
//                     <Typography sx={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
//                       {formatRelativeTime(conversation.last_message_time)}
//                     </Typography>
//                   </Box>
//                 </Box>
//                 <Typography sx={{ margin: '4px 0 0', fontSize: '12px', color: '#555' }}>
//                   {conversation.last_message.message_text}
//                 </Typography>
//               </Box>
//             </Box>
//           ))
//         ) : (
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//             <Typography sx={{ color: '#888', fontSize: '14px' }}>
//               No conversations yet
//             </Typography>
//           </Box>
//         )}
//       </Box>

//       {/* Chatbox */}
//       <Box
//         sx={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           background: '#fff',
//           borderRadius: '8px',
//           maxWidth: { md: '660px', xs: '100%' },
//           width: '100%',
//         }}
//       >
//         {/* Header section */}
//         {selectedConversation && selectedConversation.property ? (
//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: { xs: 'column', md: 'row' },
//               alignItems: 'flex-start',
//               padding: { xs: '12px', md: '25px 9px 0 9px' },
//               borderBottom: '2px solid #eee',
//               height: { xs: 'auto', md: '110px' },
//             }}
//           >
//             <img
//               src={selectedConversation.property.image}
//               alt="Property"
//               style={{
//                 width: '140px',
//                 height: '70px',
//                 borderRadius: '8px',
//                 marginRight: '22px',
//                 marginLeft: '20px',
//                 objectFit: 'cover',
//               }}
//               onError={(e) => {
//                 console.warn('Header image failed to load, using fallback');
//                 e.target.src = inboxheader;
//               }}
//             />
//             <Box>
//               <Typography sx={{ margin: 0, fontSize: '15px', fontWeight: 600 }}>
//                 {selectedConversation.property.property_name}
//               </Typography>
//               <Typography
//                 sx={{
//                   margin: '8px 0',
//                   fontSize: '16px',
//                   fontWeight: 600,
//                   color: '#2563eb'
//                 }}
//               >
//                 {selectedConversation.property.category === 'sale' 
//                   ? `${selectedConversation.property.currency}${selectedConversation.property.asking_price || 'N/A'}`
//                   : `${selectedConversation.property.currency}${selectedConversation.property.monthly_rent || 'N/A'}/month`
//                 }
//               </Typography>
//               <Typography sx={{ margin: 0, fontSize: '12px', color: '#444' }}>
//                 {selectedConversation.property.location}
//               </Typography>
//             </Box>
//             <Typography
//               sx={{
//                 marginLeft: 'auto',
//                 fontSize: '14px',
//                 color: selectedConversation.is_other_user_online || otherUserOnlineStatus ? 'green' : '#888',
//                 alignSelf: 'flex-end',
//                 marginBottom: '6px',
//               }}
//             >
//               ● {selectedConversation.is_other_user_online || otherUserOnlineStatus ? 'Online' : 'Offline'}
//             </Typography>
//           </Box>
//         ) : (
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               width: '100%',
//               height: '110px',
//               borderBottom: '2px solid #eee',
//             }}
//           >
//             <Typography sx={{ color: '#888', fontSize: '14px' }}>
//               Select a conversation
//             </Typography>
//           </Box>
//         )}

//         {/* Messages */}
//         {selectedConversation ? (
//           <>
//             <Box
//               sx={{
//                 flex: 1,
//                 padding: { xs: '16px', md: '24px' }, // ✅ Fixed: Reduced mobile padding from 24px to 16px
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: { xs: '16px', md: '28px' }, // ✅ Fixed: Reduced mobile gap from 28px to 16px
//                 overflowY: 'auto',
//               }}
//             >
//               {loadingMessages ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
//                   <CircularProgress size={24} />
//                 </Box>
//               ) : messageError ? (
//                 <Box sx={{ padding: '20px', textAlign: 'center' }}>
//                   <Typography sx={{ color: 'red', marginBottom: '10px' }}>
//                     {messageError}
//                   </Typography>
//                 </Box>
//               ) : messages.length > 0 ? (
//                 messages.map((message) => {
//                   const isSentByCurrentUser = message.sender_id === userId;
//                   return (
//                     <Box
//                       key={message.message_id}
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'flex-start',
//                         maxWidth: '100%',
//                         flexDirection: isSentByCurrentUser ? 'row-reverse' : 'row',
//                         alignSelf: isSentByCurrentUser ? 'flex-end' : 'flex-start',
//                       }}
//                     >
//                       <Avatar
//                         sx={{
//                           width: { xs: 30, md: 52 },
//                           height: { xs: 30, md: 52 },
//                           bgcolor: isSentByCurrentUser ? '#2563eb' : '#9ca3af',
//                         }}
//                       >
//                         <AccountCircle sx={{ width: '100%', height: '100%' }} />
//                       </Avatar>
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           flexDirection: 'column',
//                           marginLeft: isSentByCurrentUser ? 0 : '10px',
//                           marginRight: isSentByCurrentUser ? '10px' : 0,
//                           alignItems: isSentByCurrentUser ? 'flex-end' : 'flex-start',
//                         }}
//                       >
//                         <Typography
//                           sx={{
//                             fontSize: { xs: '12px', md: '13px' },
//                             fontWeight: 600,
//                             marginBottom: '4px',
//                             color: '#2563eb',
//                             textAlign: isSentByCurrentUser ? 'right' : 'left',
//                           }}
//                         >
//                           {message.sender_name}
//                         </Typography>
//                         <Box
//                           sx={{
//                             background: isSentByCurrentUser ? '#2563eb' : '#f1f5f9',
//                             color: isSentByCurrentUser ? '#fff' : '#000',
//                             borderRadius: '10px',
//                             padding: { xs: '8px 12px', md: '12px 16px' },
//                             fontSize: { xs: '12px', md: '13px' },
//                           }}
//                         >
//                           {message.message_text}
//                         </Box>
//                         <Box
//                           sx={{
//                             fontSize: { xs: '10px', md: '11px' },
//                             color: '#888',
//                             marginTop: '8px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '4px',
//                             justifyContent: isSentByCurrentUser ? 'flex-end' : 'flex-start',
//                           }}
//                         >
//                           {formatMessageTime(message.timestamp)}
//                           {getMessageStatusIcon(message.status, isSentByCurrentUser)}
//                         </Box>
//                       </Box>
//                     </Box>
//                   );
//                 })
//               ) : (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//                   <Typography sx={{ color: '#888', fontSize: '14px' }}>
//                     No messages yet. Start the conversation!
//                   </Typography>
//                 </Box>
//               )}
//             </Box>

//             {/* Input */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 padding: '12px 16px',
//                 borderTop: '1px solid #eee',
//                 background: '#fff',
//               }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginRight: '12px' }}>
//                 {[attachIcon, photoIcon, locationIcon].map((icon, idx) => (
//                   <Box
//                     key={idx}
//                     component="img"
//                     src={icon}
//                     sx={{ width: '32px', height: '30px', cursor: 'pointer' }}
//                   />
//                 ))}
//               </Box>
//               <InputBase
//                 placeholder="Type your message"
//                 value={inputMessage}
//                 onChange={(e) => setInputMessage(e.target.value)}
//                 onKeyPress={(e) => {
//                   if (e.key === 'Enter' && !e.shiftKey) {
//                     e.preventDefault();
//                     if (inputMessage.trim()) {
//                       sendMessage(inputMessage);
//                     }
//                   }
//                 }}
//                 sx={{
//                   flex: 1,
//                   padding: '10px 16px',
//                   borderRadius: '20px',
//                   border: '1px solid #ddd',
//                   background: '#f1f5f9',
//                   fontSize: '14px',
//                 }}
//               />
//               <IconButton
//                 sx={{ paddingLeft: '10px' }}
//                 onClick={() => {
//                   if (inputMessage.trim()) {
//                     sendMessage(inputMessage);
//                   }
//                 }}
//                 disabled={sendingMessage}
//               >
//                 <Box component="img" src={sendIcon} sx={{ width: '26px', height: '26px' }} />
//               </IconButton>
//             </Box>
//           </>
//         ) : (
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               height: '100%',
//               flexDirection: 'column',
//               padding: '20px'
//             }}
//           >
//             <Typography variant="h6" sx={{ color: '#555', marginBottom: '10px' }}>
//               Select a conversation
//             </Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
//               Choose a conversation from the list to start chatting
//             </Typography>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default ProfileInbox;

import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Box, Typography, InputBase, IconButton, Avatar, Skeleton, Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { AccountCircle } from '@mui/icons-material';
import propertyImage from '../assets/inmenu.png';
import sendIcon from '../assets/rocket.png';
import { setCurrentConversationId, setSenderId, setReceiverId, setConversations } from '../Commonlibs/userSlice';
import io from 'socket.io-client';

const imageCache = new Map();

const processImageUrl = (image) => {
  if (!image) return propertyImage;
  if (imageCache.has(image)) return imageCache.get(image);
  
  let processedUrl;
  if (image.startsWith('data:image')) {
    processedUrl = image;
  } else if (image.startsWith('/9j/') || image.startsWith('iVBOR')) {
    processedUrl = `data:image/jpeg;base64,${image}`;
  } else {
    processedUrl = propertyImage;
  }
  
  imageCache.set(image, processedUrl);
  return processedUrl;
};

const MessageStatusIcon = React.memo(({ status }) => {
  const icons = {
    sent: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    delivered: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M0.5 8L4.5 12L11.5 5" stroke="#888888" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    read: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M2.5 8L6.5 12L13.5 5" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M0.5 8L4.5 12L11.5 5" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    failed: <Typography sx={{ color: 'red', fontSize: '10px' }}>Failed</Typography>
  };
  return icons[status] || icons.sent;
});

const ConversationSkeleton = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', padding: '10px', marginBottom: '12px' }}>
    <Skeleton variant="rectangular" width={40} height={38} sx={{ borderRadius: '8px', marginRight: '12px' }} />
    <Box sx={{ flex: 1 }}>
      <Skeleton variant="text" width="60%" height={20} />
      <Skeleton variant="text" width="80%" height={16} />
    </Box>
  </Box>
);

const MessageSkeleton = ({ isSent }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: isSent ? 'row-reverse' : 'row', marginBottom: '16px' }}>
    <Skeleton variant="circular" width={52} height={52} />
    <Box sx={{ marginLeft: isSent ? 0 : '10px', marginRight: isSent ? '10px' : 0 }}>
      <Skeleton variant="text" width={100} height={16} />
      <Skeleton variant="rectangular" width={200} height={40} sx={{ borderRadius: '10px', marginTop: '4px' }} />
    </Box>
  </Box>
);

const ConversationItem = React.memo(({ conversation, isSelected, onSelect, isOnline }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageSrc, setImageSrc] = useState(propertyImage);
  const imageRef = useRef(null);
  
  const processedImageUrl = useMemo(() => processImageUrl(conversation.property?.image), [conversation.property?.image]);

  useEffect(() => {
    if (!imageRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setImageSrc(processedImageUrl);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '50px' }
    );
    observer.observe(imageRef.current);
    return () => { if (imageRef.current) observer.unobserve(imageRef.current); };
  }, [processedImageUrl]);

  const formatRelativeTime = (timestamp) => {
    if (!timestamp) return '';
    try {
      const now = new Date();
      const messageTime = new Date(timestamp);
      if (isNaN(messageTime.getTime())) return '';
      const diffInMs = now - messageTime;
      const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
      if (diffInMinutes < 1) return 'now';
      if (diffInMinutes < 60) return `${diffInMinutes}m`;
      const diffInHours = Math.floor(diffInMinutes / 60);
      if (diffInHours < 24) return `${diffInHours}h`;
      const diffInDays = Math.floor(diffInHours / 24);
      if (diffInDays < 7) return `${diffInDays}d`;
      return messageTime.toLocaleDateString();
    } catch { return ''; }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', padding: '10px', border: '2px solid #f1f1f1', borderRadius: '9px', cursor: 'pointer', marginBottom: '12px', backgroundColor: isSelected ? '#f8f9fa' : 'transparent', transition: 'background-color 0.2s ease', '&:hover': { backgroundColor: '#f8f9fa' } }} onClick={() => onSelect(conversation)}>
      <Box sx={{ position: 'relative' }} ref={imageRef}>
        {!imageLoaded && <Skeleton variant="rectangular" width={40} height={38} sx={{ borderRadius: '8px', marginRight: '12px', position: 'absolute' }} />}
        <img src={imageSrc} alt="Property" loading="lazy" style={{ width: '40px', height: '38px', borderRadius: '8px', marginRight: '12px', objectFit: 'cover', display: imageLoaded ? 'block' : 'none' }} onLoad={() => setImageLoaded(true)} onError={(e) => { e.target.src = propertyImage; setImageLoaded(true); }} />
        {isOnline && <Box sx={{ position: 'absolute', bottom: 0, right: 12, width: '10px', height: '10px', background: '#22c55e', borderRadius: '50%', border: '2px solid white' }} />}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Typography sx={{ margin: 0, fontSize: '13px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {conversation.property?.name || 'Property'}
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginLeft: '8px' }}>
            {conversation.unread_count > 0 && (
              <Box sx={{ background: '#ef4444', color: 'white', borderRadius: '50%', minWidth: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 600, padding: '0 4px' }}>
                {conversation.unread_count > 99 ? '99+' : conversation.unread_count}
              </Box>
            )}
            <Typography sx={{ fontSize: '11px', color: '#888', marginTop: '4px', whiteSpace: 'nowrap' }}>
              {formatRelativeTime(conversation.last_message_time)}
            </Typography>
          </Box>
        </Box>
        <Typography sx={{ margin: '4px 0 0', fontSize: '12px', color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {conversation.last_message?.message_text || 'No messages yet'}
        </Typography>
      </Box>
    </Box>
  );
});

const MessageItem = React.memo(({ message, userId }) => {
  const isSentByCurrentUser = message.sender_id === userId;
  
  const formatMessageTime = (timestamp) => {
    if (!timestamp) return '';
    try {
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    } catch { return ''; }
  };
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', maxWidth: '100%', flexDirection: isSentByCurrentUser ? 'row-reverse' : 'row', alignSelf: isSentByCurrentUser ? 'flex-end' : 'flex-start', marginBottom: '16px' }}>
      <Avatar sx={{ width: { xs: 30, md: 52 }, height: { xs: 30, md: 52 }, bgcolor: isSentByCurrentUser ? '#2563eb' : '#9ca3af' }}>
        <AccountCircle sx={{ width: '100%', height: '100%' }} />
      </Avatar>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginLeft: isSentByCurrentUser ? 0 : '10px', marginRight: isSentByCurrentUser ? '10px' : 0, alignItems: isSentByCurrentUser ? 'flex-end' : 'flex-start', maxWidth: '70%' }}>
        <Typography sx={{ fontSize: { xs: '12px', md: '13px' }, fontWeight: 600, marginBottom: '4px', color: '#2563eb' }}>
          {message.sender_name || 'User'}
        </Typography>
        <Box sx={{ background: isSentByCurrentUser ? '#2563eb' : '#f1f5f9', color: isSentByCurrentUser ? '#fff' : '#000', borderRadius: '10px', padding: { xs: '8px 12px', md: '12px 16px' }, fontSize: { xs: '12px', md: '13px' }, wordWrap: 'break-word', maxWidth: '100%' }}>
          {message.message_text}
        </Box>
        <Box sx={{ fontSize: { xs: '10px', md: '11px' }, color: '#888', marginTop: '8px', display: 'flex', alignItems: 'center', gap: '4px' }}>
          {formatMessageTime(message.timestamp)}
          {isSentByCurrentUser && <MessageStatusIcon status={message.status} />}
        </Box>
      </Box>
    </Box>
  );
});

const ProfileInbox = () => {
  const [conversations, setLocalConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [messageError, setMessageError] = useState(null);
  const [inputMessage, setInputMessage] = useState('');
  const [currentConversationId, setLocalCurrentConversationId] = useState(null);
  const [receiverId, setLocalReceiverId] = useState(null);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState(new Set());
  const [connectionStatus, setConnectionStatus] = useState('connecting');

  const socketRef = useRef(null);
  const messagesEndRef = useRef(null);
  const hasAutoSelectedRef = useRef(false);
  const conversationRequestTimeoutRef = useRef(null);

  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const userId = user?.id;

  const authToken = useMemo(() => user?.token || localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token'), [user?.token]);

  const scrollToBottom = useCallback(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, []);

  useEffect(() => {
    if (messages.length > 0) scrollToBottom();
  }, [messages.length, scrollToBottom]);

  const handleConversationsList = useCallback((data) => {
    console.log('📥 🎉 CONVERSATIONS RECEIVED!');
    console.log('📦 RAW Data:', JSON.stringify(data, null, 2));
    
    if (conversationRequestTimeoutRef.current) {
      clearTimeout(conversationRequestTimeoutRef.current);
      conversationRequestTimeoutRef.current = null;
    }
    
    setLoading(false);

    if (Array.isArray(data)) {
      console.log(`✅ Array with ${data.length} conversations`);
      const formattedConversations = data.map(conv => ({
        ...conv,
        unread_count: conv.unread_count || 0
      }));
      setLocalConversations(formattedConversations);
      dispatch(setConversations(formattedConversations));
    } else if (data && typeof data === 'object') {
      console.log('📦 Object received, checking structure...');
      if (data.result && Array.isArray(data.result)) {
        console.log(`✅ Found array in result with ${data.result.length} conversations`);
        const formattedConversations = data.result.map(conv => ({
          ...conv,
          unread_count: conv.unread_count || 0
        }));
        setLocalConversations(formattedConversations);
        dispatch(setConversations(formattedConversations));
      } else {
        console.error('❌ Unexpected structure:', Object.keys(data));
        setError('Invalid data structure');
      }
    } else {
      console.error('❌ Invalid type:', typeof data);
      setError('Failed to load conversations');
    }
  }, [dispatch]);

  const handleMessagesList = useCallback((data) => {
    console.log('📥 🎉 MESSAGES RECEIVED!');
    console.log('📦 RAW Data:', JSON.stringify(data, null, 2));
    setLoadingMessages(false);

    if (Array.isArray(data)) {
      console.log(`✅ Array with ${data.length} messages`);
      setMessages(data);
    } else if (data && typeof data === 'object' && data.result && Array.isArray(data.result)) {
      console.log(`✅ Found array in result with ${data.result.length} messages`);
      setMessages(data.result);
    } else {
      console.error('❌ Invalid format');
      setMessageError('Failed to load messages');
    }
  }, []);

  const handleIncomingMessage = useCallback((data) => {
    console.log('📩 NEW MESSAGE:', data);
    
    const newMessage = {
      id: data.id,
      message_id: data.id,
      conversation_id: data.conversation_id,
      message_text: data.message_text,
      sender_id: data.sender_id,
      sender_name: data.sender_name || 'User',
      receiver_id: data.receiver_id,
      timestamp: data.timestamp || new Date().toISOString(),
      status: data.status || 'delivered'
    };

    setMessages(prev => {
      if (prev.some(msg => msg.id === newMessage.id)) return prev;
      return [...prev, newMessage];
    });

    setLocalConversations(prev =>
      prev.map(conv =>
        conv.conversation_id === data.conversation_id
          ? { ...conv, last_message: { message_text: data.message_text, status: newMessage.status }, last_message_time: newMessage.timestamp }
          : conv
      )
    );
  }, []);

  const handleMessageDelivered = useCallback((data) => {
    console.log('✅ Message delivered:', data);
    if (data.message_id) {
      setMessages(prev =>
        prev.map(msg =>
          msg.id === data.message_id || msg.message_id === data.message_id ? { ...msg, status: 'delivered' } : msg
        )
      );
    }
  }, []);

  const handleNewConversation = useCallback((data) => {
    console.log('🆕 New conversation:', data);
    if (socketRef.current?.connected && userId) {
      console.log('🔄 Refreshing...');
      socketRef.current.emit('get_conversations', { user_id: parseInt(userId) });
    }
  }, [userId]);

  const handleInquiryCreated = useCallback((data) => {
    console.log('✅ Inquiry created:', data);
    if (socketRef.current?.connected && userId) {
      console.log('🔄 Refreshing...');
      socketRef.current.emit('get_conversations', { user_id: parseInt(userId) });
    }
  }, [userId]);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      setError('Please log in');
      setConnectionStatus('error');
      return;
    }

    console.log('🔌 Initializing Socket...');
    console.log('👤 User ID:', userId);

    const socket = io('https://propertydealstalk.com', {
      transports: ['websocket', 'polling'],
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 20000,
      extraHeaders: authToken ? { 'Authorization': `Bearer ${authToken}` } : {}
    });

    socketRef.current = socket;

    // Register ALL listeners BEFORE connecting
    socket.onAny((eventName, ...args) => {
      console.log(`🎯 EVENT: "${eventName}"`, args);
    });

    socket.on('connect', () => {
      console.log('✅ Socket Connected! ID:', socket.id);
      setConnectionStatus('connected');
      setError(null);

      console.log('📤 Emitting user_connected');
      socket.emit('user_connected', { user_id: parseInt(userId) });
      
      setTimeout(() => {
        console.log('📤 Emitting get_conversations');
        socket.emit('get_conversations', { user_id: parseInt(userId) });
        
        conversationRequestTimeoutRef.current = setTimeout(() => {
          if (loading) {
            console.error('⏰ TIMEOUT: No conversations after 10 seconds');
            console.error('📋 Backend may have errors in getConversations');
            setError('Backend timeout. Check server logs.');
            setLoading(false);
          }
        }, 10000);
      }, 500);
    });

    socket.on('disconnect', (reason) => {
      console.log('❌ Disconnected:', reason);
      setConnectionStatus('disconnected');
      if (reason === 'io server disconnect') socket.connect();
    });

    socket.on('connect_error', (error) => {
      console.error('⚠️ Connection error:', error.message);
      setConnectionStatus('error');
      setError('Connection failed');
      setLoading(false);
    });

    socket.on('conversations_list', handleConversationsList);
    socket.on('messages_list', handleMessagesList);
    socket.on('message_sent', handleIncomingMessage);
    socket.on('message_delivered_ack', handleMessageDelivered);
    socket.on('new_conversation', handleNewConversation);
    socket.on('inquiry_created', handleInquiryCreated);

    socket.on('user_online', (data) => {
      console.log('👤 User online:', data);
      if (data.user_id) setOnlineUsers(prev => new Set([...prev, data.user_id]));
    });

    socket.on('user_offline', (data) => {
      console.log('👤 User offline:', data);
      if (data.user_id) {
        setOnlineUsers(prev => {
          const newSet = new Set(prev);
          newSet.delete(data.user_id);
          return newSet;
        });
      }
    });

    socket.on('error', (error) => {
      console.error('🔥 Socket error:', error);
    });

    // NOW connect the socket
    console.log('🔌 Connecting socket...');
    socket.connect();

    return () => {
      console.log('🧹 Cleanup');
      if (conversationRequestTimeoutRef.current) {
        clearTimeout(conversationRequestTimeoutRef.current);
      }
      socket.offAny();
      socket.off();
      socket.disconnect();
      socketRef.current = null;
      hasAutoSelectedRef.current = false;
    };
  }, [userId, authToken, handleConversationsList, handleMessagesList, handleIncomingMessage, handleMessageDelivered, handleNewConversation, handleInquiryCreated]);

  const retryConnection = useCallback(() => {
    console.log('🔄 Retry');
    setError(null);
    setLoading(true);
    setConnectionStatus('connecting');
    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current.connect();
    }
  }, []);

  const selectConversation = useCallback((conversation) => {
    console.log('📝 Selecting:', conversation.conversation_id);
    setSelectedConversation(conversation);
    setLocalCurrentConversationId(conversation.conversation_id);
    setLoadingMessages(true);
    setMessageError(null);

    if (conversation.other_user_id) {
      setLocalReceiverId(conversation.other_user_id);
      dispatch(setReceiverId(conversation.other_user_id));
    }

    dispatch(setCurrentConversationId(conversation.conversation_id));
    if (conversation.other_user_id) dispatch(setSenderId(conversation.other_user_id));

    if (socketRef.current?.connected) {
      console.log('📤 join_conversation');
      socketRef.current.emit('join_conversation', { conversation_id: conversation.conversation_id });

      console.log('📤 get_messages');
      socketRef.current.emit('get_messages', { conversation_id: conversation.conversation_id, user_id: parseInt(userId) });
    }

    setLocalConversations(prev =>
      prev.map(conv =>
        conv.conversation_id === conversation.conversation_id ? { ...conv, unread_count: 0 } : conv
      )
    );
  }, [userId, dispatch]);

  const sendMessage = useCallback(() => {
    if (!inputMessage.trim() || !currentConversationId || !userId) return;
    const actualReceiverId = receiverId || selectedConversation?.other_user_id;
    if (!actualReceiverId || !socketRef.current?.connected) return;

    setSendingMessage(true);
    const tempMessageId = `temp-${Date.now()}`;
    const tempMessage = {
      id: tempMessageId,
      message_id: tempMessageId,
      message_text: inputMessage,
      sender_id: userId,
      sender_name: user?.fullName || user?.full_name || 'You',
      receiver_id: actualReceiverId,
      timestamp: new Date().toISOString(),
      status: 'sending',
      conversation_id: currentConversationId
    };

    setMessages(prev => [...prev, tempMessage]);
    const messageToSend = inputMessage;
    setInputMessage('');

    console.log('📤 send_message');
    socketRef.current.emit('send_message', {
      conversation_id: parseInt(currentConversationId),
      sender_id: parseInt(userId),
      receiver_id: parseInt(actualReceiverId),
      message_text: messageToSend
    });

    setSendingMessage(false);
  }, [inputMessage, currentConversationId, userId, receiverId, selectedConversation, user]);

  const handleInputChange = useCallback((e) => setInputMessage(e.target.value), []);
  const isUserOnline = useCallback((checkUserId) => onlineUsers.has(checkUserId), [onlineUsers]);

  useEffect(() => {
    if (conversations.length > 0 && !selectedConversation && !loading && !hasAutoSelectedRef.current && connectionStatus === 'connected') {
      console.log('🎯 Auto-select first');
      hasAutoSelectedRef.current = true;
      setTimeout(() => selectConversation(conversations[0]), 100);
    }
  }, [conversations, selectedConversation, loading, connectionStatus, selectConversation]);

  if (!userId) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h6">Please log in</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: '10px', md: '20px' }, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', md: '320px' }, background: '#fff', borderRadius: '8px', display: 'flex', flexDirection: 'column', padding: { xs: '12px', md: '46px 16px 0 16px' }, maxHeight: { xs: '400px', md: '600px' }, overflowY: 'auto' }}>
        {connectionStatus === 'connecting' && (
          <Box sx={{ padding: '10px', background: '#fff3cd', textAlign: 'center', borderRadius: '8px', marginBottom: '10px' }}>
            <Typography sx={{ fontSize: '12px', color: '#856404' }}>Connecting...</Typography>
          </Box>
        )}
        {connectionStatus === 'error' && error && (
          <Box sx={{ padding: '10px', background: '#f8d7da', textAlign: 'center', borderRadius: '8px', marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography sx={{ fontSize: '12px', color: '#721c24' }}>{error}</Typography>
            <Button variant="contained" size="small" onClick={retryConnection} sx={{ fontSize: '11px', padding: '4px 12px', background: '#dc3545', '&:hover': { background: '#c82333' } }}>Retry</Button>
          </Box>
        )}
        {loading ? (
          <>
            <ConversationSkeleton />
            <ConversationSkeleton />
            <ConversationSkeleton />
          </>
        ) : conversations.length > 0 ? (
          conversations.map((conversation) => (
            <ConversationItem key={conversation.conversation_id} conversation={conversation} isSelected={selectedConversation?.conversation_id === conversation.conversation_id} onSelect={selectConversation} isOnline={isUserOnline(conversation.other_user_id)} />
          ))
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography sx={{ color: '#888', fontSize: '14px' }}>No conversations</Typography>
          </Box>
        )}
      </Box>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', background: '#fff', borderRadius: '8px', maxWidth: { md: '660px', xs: '100%' }, width: '100%' }}>
        {selectedConversation?.property ? (
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'flex-start', padding: { xs: '12px', md: '25px 9px 0 9px' }, borderBottom: '2px solid #eee', height: { xs: 'auto', md: '110px' } }}>
            <img src={processImageUrl(selectedConversation.property.image)} alt="Property" loading="lazy" style={{ width: '140px', height: '70px', borderRadius: '8px', marginRight: '22px', marginLeft: '20px', objectFit: 'cover' }} onError={(e) => { e.target.src = propertyImage; }} />
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ margin: 0, fontSize: '15px', fontWeight: 600 }}>{selectedConversation.property.name || 'Property'}</Typography>
              <Typography sx={{ margin: '8px 0', fontSize: '16px', fontWeight: 600, color: '#2563eb' }}>Property Details</Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <Typography sx={{ fontSize: '14px', color: isUserOnline(selectedConversation.other_user_id) ? '#22c55e' : '#888', display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Box sx={{ width: '8px', height: '8px', borderRadius: '50%', background: isUserOnline(selectedConversation.other_user_id) ? '#22c55e' : '#888' }} />
                {isUserOnline(selectedConversation.other_user_id) ? 'Online' : 'Offline'}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '110px', borderBottom: '2px solid #eee' }}>
            <Typography sx={{ color: '#888', fontSize: '14px' }}>Select a conversation</Typography>
          </Box>
        )}

        {selectedConversation ? (
          <>
            <Box sx={{ flex: 1, padding: { xs: '16px', md: '24px' }, display: 'flex', flexDirection: 'column', overflowY: 'auto', maxHeight: { xs: '400px', md: '450px' } }}>
              {loadingMessages ? (
                <>
                  <MessageSkeleton isSent={false} />
                  <MessageSkeleton isSent={true} />
                </>
              ) : messageError ? (
                <Box sx={{ padding: '20px', textAlign: 'center' }}>
                  <Typography sx={{ color: 'red' }}>{messageError}</Typography>
                </Box>
              ) : messages.length > 0 ? (
                <>
                  {messages.map((message, index) => (
                    <MessageItem key={message.id || `msg-${index}`} message={message} userId={userId} />
                  ))}
                  <div ref={messagesEndRef} />
                </>
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography sx={{ color: '#888', fontSize: '14px' }}>No messages yet</Typography>
                </Box>
              )}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', padding: '12px 16px', borderTop: '1px solid #eee' }}>
              <InputBase placeholder="Type your message" value={inputMessage} onChange={handleInputChange} onKeyPress={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); } }} disabled={connectionStatus !== 'connected'} sx={{ flex: 1, padding: '10px 16px', borderRadius: '20px', border: '1px solid #ddd', background: '#f1f5f9', fontSize: '14px' }} />
              <IconButton sx={{ paddingLeft: '10px' }} onClick={sendMessage} disabled={sendingMessage || !inputMessage.trim() || connectionStatus !== 'connected'}>
                <Box component="img" src={sendIcon} sx={{ width: '26px', height: '26px' }} />
              </IconButton>
            </Box>
          </>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column', padding: '20px' }}>
            <Typography variant="h6" sx={{ color: '#555', marginBottom: '10px' }}>Select a conversation</Typography>
            <Typography variant="body2" color="text.secondary">Choose a conversation from the list</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ProfileInbox;